import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import LottifileLoading from "../LottifileLoading.json";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";

export default function News() {
  const { t, i18n } = useTranslation();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize time to midnight for accurate comparison

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(false);
      try {
        const response = await axios.get(`${MyDomain}News/GetAllNews`);
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(true);
      }
    };
    fetchData();
  }, []);

  if (!loading)
    return (
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Lottie
          style={{ height: 40, width: 40 }}
          animationData={LottifileLoading}
        />
      </div>
    );
  if (error) return <p>Error: {error.message}</p>;

  const handleDivClick = (TheObject, NameOfCategory) => {
    history.push({
      pathname: `/news/${NameOfCategory}`,
      state: TheObject,
    });
  };

  // Helper function to parse DD-MM-YYYY into a Date object
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day); // month is 0-indexed
  };

  return (
    <div
      style={{
        paddingTop: 50,
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
      }}
    >
      <div style={{ textAlign: "center", paddingBottom: 30 }}>
        <h1 style={{ fontWeight: 500, fontSize: 30 }}>News</h1>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
          direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
        }}
      >
        {data.map((item) => {
          const endDate = parseDate(item.dateEnd);
          const isExpired = endDate < today; // Check if the end date is in the past
          return (
            <div
              key={item.id}
              style={{
                backgroundColor: "#fff",
                cursor: "pointer",
                opacity: isExpired ? 0.5 : 1, // Apply opacity if expired
              }}
              onClick={() => handleDivClick(item, item.id)}
            >
              <div>
                <img
                  src={item.image}
                  alt="Sample"
                  style={{ width: "100%", objectFit: "cover" }}
                />
              </div>
              <div style={{ paddingTop: 15 }}>
                <h3 style={{ fontWeight: 500, fontSize: 18 }}>
                  {t("profile.SpecialOffersfrom")} {item.title}
                </h3>
                <p
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                  }}
                >
                  {/* {item.disc1} */}
                  {i18n.language === "en"
                    ? item.disc1
                    : i18n.language === "ar"
                    ? item.disc1Ar
                    : i18n.language === "he"
                    ? item.disc1He
                    : item.disc1}
                </p>
                {isExpired ? (
                  <>
                    <a style={{ paddingTop: 10, fontSize: 14, color: "red" }}>
                      Special offer is over {item.dateEnd}
                    </a>
                  </>
                ) : (
                  <>
                    <a style={{ paddingTop: 10, fontSize: 14, opacity: 0.5 }}>
                      {item.dateStart}
                    </a>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
